/* eslint-disable @reatom/unit-naming-rule */
import { useMemo } from 'react'
import styled from 'styled-components'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomPremiumPurchaseTable } from '../atoms/reatom-premium-purchase-table'

import type { PremiumPurchaseTableColumnId } from '../atoms/reatom-premium-purchase-table'
import type { PremiumPurchase } from '@root/entities/premium/model'
import type { ClassNameProps } from '@root/shared/react'

type PremiumPurchaseTableProps = ClassNameProps

export const PremiumPurchaseTable: React.FC<PremiumPurchaseTableProps> = ({
  className,
}) => {
  const model = useMemo(() => reatomPremiumPurchaseTable(), [])

  return (
    <Root className={className}>
      <Table model={model} rowHeight={40} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  height: 100%;
  min-height: 0;
`

const Table = styled(
  AppDataTable<PremiumPurchase.Purchase, PremiumPurchaseTableColumnId>,
)`
  --data-table-row-even-bg: var(--background-1);
  --data-table-row-odd-bg: var(--backgroundA-1);
  --data-table-row-border-color: var(--backgroundA-2);
`
